export const actionCopyFr = {
    next: "Suivant",
    back: "Retour",
    save: "Enregistrer",
    send: "Envoyer",
    skip: "Passer",
    skipForNow: "Je ne sais pas encore",
    continue: "Continuer",
    cancel: "Annuler",
    delete: "Supprimer",
    submit: "Envoyer",
    confirm: "Confirmer",
    add: "Ajouter",
    edit: "Modifier",
    done: "Terminé",
    stop: "Arrêter",
    retry: "Réessayer",
    download: "Télécharger",
    apply: "Appliquer",
    filter: "Filtrer",
    filters: "Filtres",
    columns: "Colonnes",
    close: "Fermer",
    search: "Rechercher",
    more: "Plus",
    none: "Aucun",
    previous: "Précédent",
    rename: "Renommer",
    duplicate: "Dupliquer",
    share: "Partager",
    clearAll: "Tout effacer",
    clearSearch: "Effacer la recherche",
    loading: "Chargement...",
    open: "Ouvrir",
    invite: "Inviter",
    saveCorrection: "Enregistrer la correction",
    saving: "Enregistrement...",
    sending: "Envoi...",
    submitting: "Envoi...",
    skipping: "Passage...",
    goingBack: "Retour en cours...",
    goingNext: "Passage à la suite...",
    cancelling: "Annulation...",
    deleting: "Suppression...",
    deleteConfirmTitle: "Êtes-vous absolument sûr(e) ?",
    deleteConfirmDescription: "Cette action est irréversible.",
    continuing: "Poursuite...",
    confirming: "Confirmation...",
    adding: "Ajout...",
    editing: "Modification...",
    finishing: "Finalisation...",
    stopping: "Arrêt...",
    retrying: "Nouvelle tentative...",
    downloading: "Téléchargement...",
};
